import React from 'react'
import { atlTheme } from '../../atlTheme'
import { windowWidth } from '../../constants/dimensions'
import { ATLAtomIcon } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import styled from 'styled-components/native'

interface ExpanderIconContainerProps {
  isWeb?: boolean
}

const ExpanderIconContainer = styled.TouchableHighlight<ExpanderIconContainerProps>`
  position: absolute;
  top: ${props =>
    props.isWeb ? '90%' : `${atlTheme.CarouselHeight - atlTheme.SpacingDistribute - atlTheme.SpacingMarginal}px`};
  left: ${props => (props.isWeb ? '95%' : `${windowWidth - atlTheme.SpacingDistribute - atlTheme.SpacingMarginal}px`)};
  z-index: 2;
`

interface ExpanderProps {
  onPressExpand?: () => void
  isWeb?: boolean
}

export const Expander: React.FunctionComponent<ExpanderProps> = props => {
  return (
    <ExpanderIconContainer onPress={props.onPressExpand} underlayColor={'transparent'} isWeb={props.isWeb}>
      <ATLAtomIcon source={icons.zoomOut} size={atlTheme.SizeIconBase} />
    </ExpanderIconContainer>
  )
}
